import { useEffect, useRef } from "react";
import { useNavigate } from "react-router-dom";

interface UseSessionExpirationProps {
  sessionData: {
    expires_at?: number;
    status?: string;
  } | null;
  isSessionExpired: boolean;
  setIsSessionExpired: (expired: boolean) => void;
}

export const useSessionExpiration = ({
  sessionData,
  isSessionExpired,
  setIsSessionExpired,
}: UseSessionExpirationProps) => {
  const navigate = useNavigate();
  const intervalRef = useRef<NodeJS.Timeout | null>(null);

  useEffect(() => {
    if (!sessionData?.expires_at || isSessionExpired) return;

    const checkSessionExpiration = () => {
      const now = Math.floor(Date.now() / 1000);
      const isExpired = now >= sessionData.expires_at!;

      if (isExpired && !isSessionExpired) {
        // Store timeout state for analytics checkout_close event
        try {
          sessionStorage.setItem('checkout_session_expired', 'true');
        } catch {
          // Ignore sessionStorage errors
        }
        setIsSessionExpired(true);
        navigate("/failed-checkout");
      }
    };

    checkSessionExpiration();

    intervalRef.current = setInterval(checkSessionExpiration, 60000);

    return () => {
      if (intervalRef.current) {
        clearInterval(intervalRef.current);
      }
    };
  }, [
    sessionData?.expires_at,
    isSessionExpired,
    setIsSessionExpired,
    navigate,
  ]);
};
